import React from 'react'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import messages from './translate'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f8f8;
  text-align: center;
  padding: 0 20px;
`

const Heading = styled.h1`
  font-size: 2em;
  margin-bottom: 0.5em;
`

const Message = styled.p`
  font-size: 1.2em;
`

const MaintenancePage = ({ intl: { formatMessage } }) => (
  <Container>
    <Heading>{formatMessage(messages.maintenanceHeading)}</Heading>
    <Message>{formatMessage(messages.maintenanceMessage)}</Message>
  </Container>
)

export default injectIntl(MaintenancePage)
